import xlsx from "json-as-xlsx";
import moment from 'moment';
const FertilizantesExportar = (content) => {
    let columns = [
        { label: 'ID Fertilizante', value: 'id_producto_comercial' },
        { label: 'Nombre', value: 'nombre_producto_comercial' },
        { label: 'Marca', value: 'nombre_producto_comercial_marca' },
        { label: 'Ingredientes activos', value: 'ingredientes_activos' },
        { label: 'Fecha registro', value: 'created_at' }
      ]
      
      let settings = {
        sheetName: 'Fertilizantes',
        fileName: 'Fertilizantes_' + moment().format("YYYYMMDD_HHmmss"),
        extraLength: 3,
        writeOptions: {}
      }
      
      xlsx(columns, content, settings, true);
  };
  export default FertilizantesExportar;